// Shared image-upload helper — POSTs base64 to the generic /api/upload
// endpoint (Supabase Storage `vendor-media` bucket). Same endpoint the
// vendor-apply flow uses; `purpose: "listing"` stores under listing/.
export const uploadImage = (file, purpose = "listing") =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const base64 = e.target.result.split(",")[1];
        const res = await fetch("/api/upload", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data: base64, mime: file.type, purpose }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Upload failed");
        resolve(data.url);
      } catch (err) { reject(err); }
    };
    reader.onerror = () => reject(new Error("Could not read file"));
    reader.readAsDataURL(file);
  });
